class DebtCalculator {
  static computeDebtStd = (debtBalance, debtApr, monthlyPayment) => {
    console.log(`===== Computing Debt Std: debtBalance:${debtBalance}, debtApr=${debtApr}, monthlyPayment:${monthlyPayment}`);
    let numMonthlyPayments = 0;
    let totalInterestPaid = 0;
    let paymentsSchedule = [];
  
    do {
      const monthStartingBalance = debtBalance;
      const interestPayment = (debtBalance * debtApr) / 12;
      let monthEndingBalance = debtBalance - monthlyPayment + interestPayment;
  
      numMonthlyPayments += 1;
      totalInterestPaid += interestPayment;
  
      let payment = monthlyPayment;
      // If this is the last payment then the remaining (debt-balance + interest) might be lower than the monthly-payment. In this case see if the (debt-balance + interest) can be paid off
      if (debtBalance + interestPayment < payment) {
        payment = debtBalance + interestPayment;
        monthEndingBalance = 0;
      }
  
      paymentsSchedule.push({
        month: numMonthlyPayments,
        startingBalance: Number(monthStartingBalance.toFixed(2)),
        interest: Number(interestPayment.toFixed(2)),
        payment: Number(payment.toFixed(2)),
        endingBalance: Number(monthEndingBalance.toFixed(2)),
      })
  
      debtBalance = monthEndingBalance;
    } while (debtBalance > 0);
  
    console.log(
      `Months: ${numMonthlyPayments}, Interest: ${totalInterestPaid}`
    );
    return {
      numMonthlyPayments,
      totalInterestPaid: Math.round(totalInterestPaid * 100) / 100,
      paymentsSchedule: paymentsSchedule,
    };
  }

  static computeDebtSeraBasic = (
    debtBalance,
    debtApr,
    monthlyIncome,
    monthlyNonCCExpenses,
    monthlyPayment,
    monthlySavings,
    useFlatFees,
    flatFees,
    percentageFees
  ) => {
    console.log('===== Computing Debt Basic =====');
    const monthlyExpenses = monthlyIncome - monthlyPayment - monthlySavings - monthlyNonCCExpenses;
    const daysInMonth = 30;
    const dailyExpenses =
      Math.round((monthlyExpenses / daysInMonth) * 100) / 100;
    
    let checkingBalance = 0;
    let daysSoFar = 1;
    let deductedNonCCExpenses = 0;
    let remainingNonCCExpenses = 0;
    let debtBalanceRegular = debtBalance;
  
    const paymentsSchedule = [];
  
    do {
      const debtBalanceStart = debtBalance;
      const checkingBalanceStart = checkingBalance;

      const debtBalanceRegularStart = debtBalanceRegular;
  
      let dayOfMonth = daysSoFar % daysInMonth;
      if (dayOfMonth === 0) {
        dayOfMonth = 30;
      }
  
      // Assumes income paid on the 1st and 16th
      let payment = 0;
      let income = 0;
      let savings = 0;
      let dailyInterest = 0;
      let dailyInterestRegular = 0;
      let fees = 0;

      if ([1, 16].includes(dayOfMonth)) {
        income = monthlyIncome / 2;
        savings = monthlySavings / 2;

        //income -= savings;

        if (dayOfMonth === 1) {
          // Pay the monthly payment with the first paycheck
          payment = monthlyPayment;

          // Deduct the non-CC expenses
          if (monthlyNonCCExpenses < (income - savings - payment)) {
            deductedNonCCExpenses = monthlyNonCCExpenses;
            remainingNonCCExpenses = 0;
          } else {
            deductedNonCCExpenses = income - savings - payment;
            remainingNonCCExpenses = monthlyNonCCExpenses - deductedNonCCExpenses;
          }
        } else {
          deductedNonCCExpenses = remainingNonCCExpenses;
          remainingNonCCExpenses = 0;
        }
        //income -= deductedNonCCExpenses;
      } else {
        deductedNonCCExpenses = 0;
      }

      // Keep track of the regular debt-balance
      let regularPayment = payment;
      if (regularPayment > debtBalanceRegular) {
        regularPayment = debtBalanceRegular;
      }
      debtBalanceRegular -= regularPayment;
      dailyInterestRegular = (debtBalanceRegular * debtApr) / 365
      debtBalanceRegular += dailyInterestRegular;
  
      if (payment > debtBalance) {
        payment = debtBalance;
      }

      debtBalance -= payment;
      checkingBalance += (income - savings - deductedNonCCExpenses - payment);

      // Move everything in checking to debt
      let offsetPayment = checkingBalance;
      if (offsetPayment > debtBalance) {
        offsetPayment = debtBalance;
      }
      debtBalance -= offsetPayment;
      checkingBalance -= offsetPayment;

      // Add daily-expenses to debt-balance
      debtBalance += dailyExpenses;

      dailyInterest = (debtBalance * debtApr) / 365;

      // Add daily-interest to debt-balance
      debtBalance += dailyInterest;

      // Calculate fees
      if (useFlatFees) {
        // Add the fees at the end of the month
        if (dayOfMonth === 30) {
          fees = flatFees;
        }
      } else {
        fees = (dailyInterestRegular - dailyInterest) * percentageFees/100;
      }
      
      debtBalance += fees;

      // If we can pay off the balance - do it now
      if (checkingBalance > debtBalance) {
        checkingBalance -= debtBalance;
        debtBalance = 0;
      }

      paymentsSchedule.push({
        month: Math.ceil((daysSoFar) / 30),
        daysSoFar,
        dayOfMonth,
        debtBalanceStart: Number(debtBalanceStart.toFixed(6)),
        debtBalanceRegularStart: Number(debtBalanceRegularStart.toFixed(6)),
        checkingBalanceStart: Number(checkingBalanceStart.toFixed(6)),
        debtBalanceEnd: Number(debtBalance.toFixed(6)),
        debtBalanceRegularEnd: Number(debtBalanceRegular.toFixed(6)),
        checkingBalanceEnd: Number(checkingBalance.toFixed(6)),
        dailyInterest: Number(dailyInterest.toFixed(6)),
        dailyInterestRegular: Number(dailyInterestRegular.toFixed(6)),
        fees: fees,
        expenses: Number(dailyExpenses.toFixed(6)),
        deductedNonCCExpenses:  Number(deductedNonCCExpenses.toFixed(6)),
        remainingNonCCExpenses:  Number(remainingNonCCExpenses.toFixed(6)),
        income: Number(income.toFixed(6)),
        savings: Number(savings.toFixed(6)),
        payment: Number(payment.toFixed(6)),
      });
      
      daysSoFar += 1;

    } while (debtBalance > 0);
  
    return {
      numMonthlyPayments: [...new Set(paymentsSchedule.map(item => item.month))].length,
      totalInterestPaid: parseInt(paymentsSchedule.reduce((n, {dailyInterest}) => n + Number(dailyInterest), 0)),
      totalInterestStd: parseInt(paymentsSchedule.reduce((n, {dailyInterestRegular}) => n + Number(dailyInterestRegular), 0)),
      paymentsSchedule,
    };
  }

  static computeDebtSeraSolo = (
    locBalance,
    locApr,
    debtApr,
    monthlyIncome,
    monthlyNonCCExpenses,
    nonCCExpensesDeductionDOM,
    monthlyPayment,
    monthlySavings,
    useFlatFees,
    flatFees,
    percentageFees,
    useCreditForExpenses = true
  ) => {
    console.log('===== Computing Debt Adr =====');
    const monthlyExpenses = monthlyIncome - monthlyPayment - monthlySavings - monthlyNonCCExpenses;
    const daysInMonth = 30;
    const dailyExpenses =
      Math.round((monthlyExpenses / daysInMonth) * 100) / 100;
    let totalInterestPaid = 0;
    let totalInterestCharge = 0;
    let totalInterestStd = 0;
    let totalInterestOffset = 0;
    let checkingBalance = 100;
    let savingsBalance = 0;
    let daysSoFar = 1;
    let deductedNonCCExpenses = 0;
    let remainingNonCCExpenses = 0;
  
    const paymentsSchedule = [];
  
    do {
      const locBalanceStart = locBalance;
      const checkingBalanceStart = checkingBalance;
      const savingsBalanceStart = savingsBalance;
      let fees = 0;
  
      let dayOfMonth = daysSoFar % daysInMonth;
      if (dayOfMonth === 0) {
        dayOfMonth = 30;
      }
  
      // Assumes income paid on the 1st and 16th
      let locPayment = 0;
      let income = 0;
      let savings = 0;

      if ([1, 16].includes(dayOfMonth)) {
        //locPayment = monthlyPayment / 2;
        income = monthlyIncome / 2;
        savings = monthlySavings / 2;
        savingsBalance += savings;

        income -= savings;

        if (dayOfMonth === 1) {
          // Pay the monthly payment with the first paycheck
          locPayment = monthlyPayment;

          // Deduct the non-CC expenses
          /*if (monthlyNonCCExpenses < (income - locPayment)) {
            deductedNonCCExpenses = monthlyNonCCExpenses;
            remainingNonCCExpenses = 0;
          } else {
            deductedNonCCExpenses = income - locPayment;
            remainingNonCCExpenses = monthlyNonCCExpenses - deductedNonCCExpenses;
          }*/
        }/* else {
          deductedNonCCExpenses = remainingNonCCExpenses;
          remainingNonCCExpenses = 0;
        }
        income -= deductedNonCCExpenses;*/
      }/* else {
        deductedNonCCExpenses = 0;
      }*/
  
      locBalance -= locPayment;
      checkingBalance += income - locPayment;
  
      // Substract expenses: Asset Acceleration
      let expenses = 0;
      if (useCreditForExpenses) {
        if (dayOfMonth === 30) {
          expenses = monthlyExpenses;
        }
      } else {
        // Substract expenses: No Asset Acceleration
        expenses = dailyExpenses;

        // If the checking account does not have enough for the daily expenses - move it from the LOC account
        /*if ((checkingBalance - expenses) < 0) {
          locBalance += dailyExpenses;
          checkingBalance += dailyExpenses;
        }*/
      }
  
      checkingBalance = checkingBalance - expenses;

      // Deduct the non-CC expenses
      if (dayOfMonth === nonCCExpensesDeductionDOM) {
        // Deduct the non-CC expenses
        if (monthlyNonCCExpenses <= checkingBalance) {
          deductedNonCCExpenses = monthlyNonCCExpenses;
          remainingNonCCExpenses = 0;
        } else {
          deductedNonCCExpenses = checkingBalance;
          remainingNonCCExpenses = monthlyNonCCExpenses - deductedNonCCExpenses;
        }
      } else if (dayOfMonth === 16) {
        deductedNonCCExpenses = remainingNonCCExpenses;
        remainingNonCCExpenses = 0;
      } else {
        deductedNonCCExpenses = 0;
      }
      checkingBalance -= deductedNonCCExpenses;
  
      // Calculate offset balance
      let offsetBalance = locBalance - checkingBalance - savingsBalance;
      if (offsetBalance < 0) {
        offsetBalance = 0;
      }
  
      // standard daily interest
      const locInterestStd = (locBalance * debtApr) / 365;
  
      // offset daily interest
      const locInterestOffset = (offsetBalance * locApr) / 365;
  
      if (useFlatFees) {
        // Add the fees at the end of the month
        if (dayOfMonth === 30) {
          fees = flatFees;
        }
      } else {
        fees = (locInterestStd - locInterestOffset) * percentageFees/100;
      }
  
      // daily interest for consumer with 10% savings fees
      const locInterest = locInterestOffset + fees;
  
      /*console.log(
        `${daysSoFar}: intStd: ${locInterestStd}, intOffset: ${locInterestOffset}, diff: ${
          locInterestStd - locInterestOffset
        }, locInterestCharge: ${locInterestCharge}, locInterest: ${locInterest}`
      );*/
  
      // Add LOC interest to balance
      locBalance = locBalance + locInterest;
  
      /*console.log(
        `Month: ${Math.ceil(
          daysSoFar / 30
        )}: ${dayOfMonth}: LOC: ${locBalance}, Checking: ${checkingBalance}, Interest: ${locInterest}, Expenses: ${expenses}, Income: ${income}, Payment: ${locPayment}`
      );*/
  
      totalInterestPaid += locInterest;
      totalInterestStd += locInterestStd;
      totalInterestOffset += locInterestOffset;
      totalInterestCharge += fees;
    
      paymentsSchedule.push({
        month: Math.ceil((daysSoFar) / 30),
        daysSoFar,
        dayOfMonth,
        locBalanceStart: Number(locBalanceStart.toFixed(6)),
        checkingBalanceStart: Number(checkingBalanceStart.toFixed(6)),
        savingsBalanceStart: Number(savingsBalanceStart.toFixed(6)),
        locBalanceEnd: Number(locBalance.toFixed(6)),
        checkingBalanceEnd: Number(checkingBalance.toFixed(6)),
        savingsBalanceEnd: Number(savingsBalance.toFixed(6)),
        offsetBalance: Number(offsetBalance.toFixed(6)),
        locInterest: Number(locInterest.toFixed(6)),
        locInterestStd: Number(locInterestStd.toFixed(6)),
        locInterestOffset: Number(locInterestOffset.toFixed(6)),
        fees: Number(fees.toFixed(6)),
        expenses: Number(expenses.toFixed(6)),
        deductedNonCCExpenses:  Number(deductedNonCCExpenses.toFixed(6)),
        remainingNonCCExpenses:  Number(remainingNonCCExpenses.toFixed(6)),
        income: Number(income.toFixed(6)),
        savings: Number(savings.toFixed(6)),
        locPayment: Number(locPayment.toFixed(6)),
      });

      daysSoFar += 1;

    } while (locBalance > 0);
  
    /*console.log(
      `Days: ${daysSoFar}, Months: ${Math.ceil(
        daysSoFar / 30
      )}, Interest: ${totalInterestPaid.toFixed(2)}, APR: ${locApr}, MonthlySavings: ${monthlySavings}`
    );*/
    return {
      numMonthlyPayments: Math.floor(daysSoFar / daysInMonth),
      totalInterestPaid: Math.round(totalInterestPaid * 100) / 100,
      totalInterestCharge: Math.round(totalInterestCharge * 100) / 100,
      totalInterestStd: Math.round(totalInterestStd * 100) / 100,
      totalInterestOffset: Math.round(totalInterestOffset * 100) / 100,
      paymentsSchedule,
    };
  }
}

export default DebtCalculator;